import { Component, OnInit, HostListener, OnDestroy, Directive } from '@angular/core';
import { ApiService, ABCisApi } from 'src/app/handlers/apiHandler.service';

/**
 * The document editor component is used to check what documents are being viewed
 */
@Directive()
export abstract class DocumentEditorComponent implements OnDestroy {
  /** 
   * The uuid of the file being viewed
   */ 
  public uuid: string;
  constructor(private abcisApiHandler: ApiService) { }

  /**
   * Sets the class' uuid and posts it to the handling api
   * @param uuid The uuid being set
   */
  public setDocumentId(uuid: string) {
    //this.uuid = uuid;
    //this.abcisApiHandler.postABCisRequest(ABCisApi.Files, "iamlookingatfile", this.uuid);
  }

  /**
   * When the conponent is destroyed tell the api
   */
  ngOnDestroy(): void {
    //this.NoLongerLookingAtFile();
  }

  /**
   * On the window being unloaded (event before on closed). Tell the api
   */
  @HostListener('window:beforeunload', [ '$event' ])
  beforeUnloadHander(event) {
    //this.NoLongerLookingAtFile();
  }

  /**
   * The user is no longer looking at the file. Send the request.
   */
  NoLongerLookingAtFile() {
    if (this.uuid !== null && this.uuid !== undefined) {
      //this.abcisApiHandler.postABCisRequest(ABCisApi.Files, "iamnolongerlookingatfile", this.uuid);
      //this.uuid = undefined;
    }
  }
}
